import PermissionGuard from 'components/Global/PermissionGuard';
import RoleTable from 'components/Settings/Role';
export const Roles = () => {
	return (
		<PermissionGuard permission="Allow_Roles">
			<RoleTable />
		</PermissionGuard>
	);
};
